import { render, staticRenderFns } from "./ProductTemplateCreate.vue?vue&type=template&id=18061f4c"
import script from "./ProductTemplateCreate.vue?vue&type=script&lang=js"
export * from "./ProductTemplateCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports